// TODO: THIS CODE WILL BE REFACTORED, IT IS ONLY FOR QUICK SPLIT TESTS
import $ from 'jquery';
import MobileTable from './mobile-table/index';

const MAX_MOBILE_VIEW_WIDTH = 600;

export default function manageTableViews($tableWrapper) {
  if (isScrolledTableSupported($tableWrapper) === false) {
    return;
  }

  let mobileTable = null;
  const $table = $tableWrapper.find('table');

  if (isMobileView($tableWrapper)) {
    mobileTable = updateTableToMobileVersion($table);
  }

  // TODO: needs refactor
  $(window).on('resize', () => {
    const isMobile = isMobileView($tableWrapper);
    if (isMobile && mobileTable === null) {
      mobileTable = updateTableToMobileVersion($table);
    } else if (!isMobile && mobileTable) {
      mobileTable = updateTableToDesktopVersion(mobileTable);
    }
  });
}

function updateTableToMobileVersion($table) {
  const mobileTable = new MobileTable($table);
  mobileTable.initialize();
  return mobileTable;
}

function updateTableToDesktopVersion(mobileTable) {
  mobileTable.destroy();
  return null;
}

function isMobileView() {
  return window.innerWidth <= MAX_MOBILE_VIEW_WIDTH;
}

function isScrolledTableSupported($tableWrapper) {
  return $tableWrapper.hasClass('comparison-calculator--modern_scrolled_mobile') ||
          $tableWrapper.hasClass('comparison-calculator--modern_mobile');
}
